// map.js
var DKT = DKT || {};
DKT.map = function(
  $,
  L,
  DKTConfiguration,
  DKTUtils,
  DKTFavorites,
  donostiaQuartersGeoJSON,
  mapConfiguration,
  tamborradasPorZona,
  actualLanguage,
  tamborradasLinks,
  translations,
  zonesLinks,
  existeGoogleAnalytics
) {
  var myMap;

  function init() {
    if(document.querySelector('#map')){
      initializeMap();
      addQuarters();
    }
  }

  function initializeMap() {
    var googleMaps;

    googleMaps = new L.Google("ROADMAP", {
      mapOptions: {
        styles: mapConfiguration
      }
    });

    myMap = L.map("map", {
      center: DKTConfiguration.MAP_CENTER_COORDINATES,
      zoom: 14,
      layers: [googleMaps],
      zoomControl: false,
      attributionControl: false,
      gestureHandling: true,
      gestureHandlingOptions: {
        duration: 1500,
        text: {
          touch: DKTConfiguration.TEXT_MAP_TOUCH,
          scroll: DKTConfiguration.TEXT_MAP_SCROLL,
          scrollMac: DKTConfiguration.TEXT_MAP_SCROLL_MAC
        }
      }
    });

    var fullscreenControl = new L.Control.Fullscreen({ position: "bottomright" });
    fullscreenControl.addTo(myMap);

    var control = L.control.zoom({ position: "bottomleft" });
    control.addTo(myMap);

    myMap.on("zoomend", repositionPopup);
    myMap.on("popupclose", function(e) {
      removePolylineDecorator(e, true);
    });
    myMap.on("fullscreenchange", function() {
      if (myMap.isFullscreen()) {
        myMap.gestureHandling.disable();
        if (existeGoogleAnalytics) ga("gtm1.send", "event", "mapa", "fullscreen", window.location.href);
      } else {
        myMap.gestureHandling.enable();
        myMap.removeControl(fullscreenControl);
        myMap.addControl(fullscreenControl);
      }
    });
    $("#map").on("custom_toggleFav", handleFavToggleFromMap);

    myMap.on("click", function() {
      if (existeGoogleAnalytics) ga("gtm1.send", "event", "mapa", "click", window.location.href);
    });
    myMap.on("dragstart", function() {
      if (existeGoogleAnalytics) ga("gtm1.send", "event", "mapa", "mover", window.location.href);
    });
    myMap.on("zoomend", function() {
      if (existeGoogleAnalytics) ga("gtm1.send", "event", "mapa", "zoom", window.location.href);
    });
  }

  function handleFavToggleFromMap(e, tamborradaId, action) {
    var color;
    if (action === "add") {
      color = DKTConfiguration.PATHS_FAVORITE_COLOR;
    } else if (action === "remove") {
      color = DKTConfiguration.PATHS_MAIN_COLOR;
    }

    if (typeof pathGroup !== "undefined" && pathGroup.length > 0) {
      var actualPolyline;
      for (var i = 0; i < pathGroup.length; i++) {
        var polyline = pathGroup[i];
        if (polyline.options.tamborradaId == tamborradaId) {
          actualPolyline = polyline;
          break;
        }
      }
      if (actualPolyline) {
        actualPolyline.setStyle({
          color: color
        });
      }
    }

    if (typeof startingPointsGroup !== "undefined" && startingPointsGroup.length > 0) {
      //https://stackoverflow.com/a/858193
      var actualStartingPoint;
      for (var i = 0; i < startingPointsGroup.length; i++) {
        var startingPoint = startingPointsGroup[i];
        if (startingPoint.options.tamborradaId == tamborradaId) {
          actualStartingPoint = startingPoint;
          break;
        }
      }
      if (actualStartingPoint) {
        var icon = getIcon(tamborradaId);
        actualStartingPoint.setIcon(icon);
      }
    }
  }

  // #region Popups
  function addPopup(e, polylineOptions, element) {
    var name = polylineOptions.name;
    var startFormattedDate = DKTUtils.getFormattedDateOnlyTime(polylineOptions.startTime);
    var endFormattedDate = DKTUtils.getFormattedDateOnlyTime(polylineOptions.endTime);

    var tamborradaId = element.options.tamborradaId;
    var isFavorite = DKTFavorites.isFavorite(tamborradaId);
    var checked = isFavorite ? 'checked="checked"' : "";
    var imgTamborzon = isFavorite ? DKTConfiguration.URL_IMG_TAMBORZON_ON : DKTConfiguration.URL_IMG_TAMBORZON_OFF;
    var linkObject = tamborradasLinks.filter(function(item) {
      return item.id == tamborradaId;
    })[0];
    var link = linkObject ? linkObject.url : "#";

    var dateLine;
    if (actualLanguage === "es-ES") {
      dateLine = "<span>De " + startFormattedDate + " a " + endFormattedDate + "</span><br/>";
    } else {
      dateLine = "<span>" + startFormattedDate + "-tik " + endFormattedDate + "-ra</span><br/>";
    }

    var content =
      "<div>" +
      "<a href=" +
      link +
      "><strong>" +
      name +
      "</strong></a> <br/>" +
      dateLine +
      "<label>" +
      '<img data-tamborrada-id="' +
      tamborradaId +
      '" src="' +
      imgTamborzon +
      '">' +
      '<input class="checkFav" data-tamborrada-id="' +
      tamborradaId +
      '" type="checkbox" ' +
      checked +
      "/>" +
      translations.markAsFavorite +
      "</label>" +
      "</div>";

    L.popup({ className: "fixed-popup", autoPanPaddingTopLeft: [0, 80], minWidth: 220 })
      .setLatLng(e.latlng)
      .setContent(content)
      .openOn(myMap);

    element.fireEvent("custom_popupopen");

    if ("icon" in element.options) {
      repositionElementType = "marker";
    } else {
      repositionElementType = "other";
    }
    repositionPopup();
  }

  var repositionElementType = null;
  function repositionPopup() {
    var popup = document.getElementsByClassName("fixed-popup")[0];

    if (popup) {
      var popupHeight = popup.clientHeight;
      var popupWidth = popup.clientWidth;
      var popupTranslate3d = popup.style.transform;
      var popupTranslate3dX = Number(popupTranslate3d.split("px")[0].split("(")[1]);
      var popupTranslate3dY = Number(popupTranslate3d.split("px")[1].split(" ")[1]);

      var newX = popupTranslate3dX - Math.round(popupWidth / 2);
      var newY = popupTranslate3dY - (popupHeight + 10); // 10px extra por la flecha del bocadillo (cuya altura es 20px)

      if (repositionElementType === "marker") {
        newY = newY - 50;
        newX = newX - 1;
      }

      popup.style.transform = "translate3d(" + newX + "px, " + newY + "px, 0px)";
    }
  }
  // #endregion

  // #region QuarterAreas
  var quarterAreas = [];
  function addQuarters() {
    var quarterOptions = {
      style: function(feature) {
        return { color: "rgba(0,0,0,0)", clickable: false };
      },
      onEachFeature: function(feature, layer) {
        var coordinatesPoints;
        coordinatesPoints = feature.geometry.coordinates[0].map(function(point) {
          return [point[1], point[0]];
        });
        quarterAreas.push({
          name: feature.properties.BAR_DS_O,
          BAR_BARR: feature.properties.BAR_BARR,
          polygon: L.polygon(coordinatesPoints)
        });
      }
    };
    L.geoJson(donostiaQuartersGeoJSON, quarterOptions).addTo(myMap);
  }
  // #endregion

  // #region QuarterCounts
  var quarterCountMarkers = [];
  function drawQuarterCount(groupedTamborradas) {
    groupedTamborradas.forEach(function(group, index) {
      var zoneId = group.zoneId;
      var markerPosition;
      for (var i = 0; i < tamborradasPorZona.length; i++) {
        if (tamborradasPorZona[i].id === zoneId) {
          markerPosition = tamborradasPorZona[i].markerPosition;
          break;
        }
      }

      if (markerPosition) {
        var numberTamborradas = group.tamborradas.length;
        var markerIconOptions = {
          color: "rgb(13,63,144)",
          size: 16
        };
        var zonesLinksFiltered = zonesLinks.filter(function(item) {
          return item.id == zoneId;
        });
        if (zonesLinksFiltered.length > 0) {
          var zoneLink = zonesLinksFiltered[0].url;
        } else {
          var zoneLink = "";
        }

        var markerIcon = L.bigMarkerIcon(numberTamborradas, markerIconOptions);
        var marker = L.marker(markerPosition, { icon: markerIcon, clickable: true, link: zoneLink }).addTo(myMap);
        subscribeQuarterCount(marker);
        quarterCountMarkers.push(marker);
      }
    });
  }

  function eraseQuarterCount() {
    quarterCountMarkers.forEach(function(marker) {
      unsubscribeQuarterCount(marker);
      myMap.removeLayer(marker);
    });
  }

  function subscribeQuarterCount(marker) {
    marker.on("click", function(e) {
      ga("gtm1.send", "event", "mapa", "click barrio", window.location.href);
      window.location.href = e.target.options.link;
    });
  }

  function unsubscribeQuarterCount(marker) {
    marker.off();
  }

  function zoomToFitAllQuarterCounts() {
    var points = quarterCountMarkers.map(function(item) {
      return item._latlng;
    });

    if (points && points.length > 0) {
      myMap.fitBounds(points, { padding: [15, 15] });
    }
  }
  // #endregion

  // #region StartingPoints
  var startingPointsGroup = [];
  function drawStartingPoints(filteredTamborradas) {
    eraseStartingPoints();
    filteredTamborradas.forEach(function(tamborrada) {
      var startingPoint = addStartingPoint(tamborrada);
      if (startingPoint) {
        subscribeStartingPointListeners(startingPoint);
        startingPointsGroup.push(startingPoint);
      }
    });
  }

  function eraseStartingPoints() {
    startingPointsGroup.forEach(unsubscribeStartingPointListeners);
    startingPointsGroup.forEach(removeStartingPoint);
    startingPointsGroup = [];
  }

  function addStartingPoint(tamborrada) {
    var icon = getIcon(tamborrada.id);

    var startingPointOptions = {
      name: tamborrada.name,
      startTime: tamborrada.startTime,
      endTime: tamborrada.endTime,
      tamborradaId: tamborrada.id,
      icon: icon
    };

    var marker = null;
    if (tamborrada.startingPoint) {
      marker = L.marker(tamborrada.startingPoint, startingPointOptions).addTo(myMap);
    }

    return marker;
  }

  function removeStartingPoint(startingPoint) {
    myMap.removeLayer(startingPoint);
  }

  function getIcon(tamborradaId) {
    var iconUrl;
    if (DKTFavorites.isFavorite(tamborradaId)) {
      iconUrl = DKT.markerIMGs.favorite;
    } else {
      iconUrl = DKT.markerIMGs.default;
    }
    var icon = L.icon({
      iconUrl: iconUrl,
      iconSize: [48, 55],
      iconAnchor: [20, 55],
      shadowUrl: DKT.markerIMGs.shadow,
      shadowSize: [48, 55],
      shadowAnchor: [20, 55]
    });

    return icon;
  }

  function subscribeStartingPointListeners(startingPoint) {
    startingPoint.on("click", function(e) {
      addPopup(e, startingPoint.options, startingPoint);
    });
  }

  function unsubscribeStartingPointListeners(startingPoint) {
    startingPoint.off();
  }

  function zoomToFitAllStartingPoints() {
    var points = startingPointsGroup.map(function(item) {
      return item._latlng;
    });

    if (points && points.length > 0) {
      myMap.fitBounds(points, { paddingTopLeft: [0, 80] });
    }
  }
  // #endregion

  // #region Paths
  var pathGroup = [];
  function drawPaths(filteredTamborradas) {
    erasePaths();
    filteredTamborradas.forEach(function(tamborrada) {
      var polyline = addPolyline(tamborrada);
      if (polyline) {
        subscribePolylineListeners(polyline);
        pathGroup.push(polyline);
      }
    });
  }

  function erasePaths() {
    pathGroup.forEach(unsubscribePolylineListeners);
    pathGroup.forEach(removePolyline);
    pathGroup = [];
  }

  function addPolyline(tamborrada) {
    var color = DKTFavorites.isFavorite(tamborrada.id)
      ? DKTConfiguration.PATHS_FAVORITE_COLOR
      : DKTConfiguration.PATHS_MAIN_COLOR;

    var polyline = null;
    if (tamborrada.path) {
      polyline = L.polyline(tamborrada.path, {
        color: color,
        weight: DKTConfiguration.PATHS_POLYLINE_WEIGHT_DEFAULT,
        opacity: 0.5,
        name: tamborrada.name,
        startTime: tamborrada.startTime,
        endTime: tamborrada.endTime,
        tamborradaId: tamborrada.id
      }).addTo(myMap);
    }

    return polyline;
  }

  function removePolyline(polyline) {
    myMap.removeLayer(polyline);
  }

  function subscribePolylineListeners(polyline) {
    polyline.on("mouseover", function(e) {
      addPolylineDecorator(e, false);
    });
    polyline.on("mouseout", function(e) {
      removePolylineDecorator(e, false);
    });
    polyline.on("click", function(e) {
      addPopup(e, polyline.options, polyline);
    });
    polyline.on("custom_popupopen", function(e) {
      addPolylineDecorator(e, true);
    });
  }

  function unsubscribePolylineListeners(polyline) {
    polyline.off();
  }

  var polylineDecoratorGroup = [];
  var polylinesKeepingDecorator = [];
  function addPolylineDecorator(e, keepDecorator) {
    if (keepDecorator) {
      removePolylineDecorator(e, true);
    } else {
      removePolylineDecorator(e, false);
    }
    var layer = e.target;
    layer.setStyle({
      opacity: 1,
      weight: DKTConfiguration.PATHS_POLYLINE_WEIGHT_SELECTED
    });

    var polylineDecorator = L.polylineDecorator(layer._latlngs, {
      patterns: [
        {
          offset: 0,
          repeat: 70,
          symbol: L.Symbol.arrowHead({ pixelSize: 10, pathOptions: { fillOpacity: 1, weight: 0, color: "white" } })
        }
      ],
      keepDecorator: keepDecorator
    }).addTo(myMap);

    polylineDecoratorGroup.push(polylineDecorator);
    if (keepDecorator) {
      polylinesKeepingDecorator.push(layer);
    }
  }

  function removePolylineDecorator(e, forceRemove) {
    if (forceRemove) {
      polylinesKeepingDecorator.forEach(function(layer) {
        layer.setStyle({
          opacity: 0.5,
          weight: DKTConfiguration.PATHS_POLYLINE_WEIGHT_DEFAULT
        });
      });
      polylinesKeepingDecorator = [];

      polylineDecoratorGroup.forEach(function(polylineDecorator) {
        myMap.removeLayer(polylineDecorator);
      });
      polylineDecoratorGroup = [];
    } else {
      var layer = e.target;
      var shouldRemoveDecorator = true;
      polylinesKeepingDecorator.forEach(function(item) {
        if (layer._leaflet_id === item._leaflet_id) {
          shouldRemoveDecorator = false;
        }
      });
      if (shouldRemoveDecorator) {
        layer.setStyle({
          opacity: 0.5,
          weight: DKTConfiguration.PATHS_POLYLINE_WEIGHT_DEFAULT
        });
      }

      polylineDecoratorGroup.forEach(function(polylineDecorator, index) {
        if (!polylineDecorator.options.keepDecorator) {
          myMap.removeLayer(polylineDecorator);
          polylineDecoratorGroup.splice(index, 1);
        }
      });
    }
  }

  function zoomToSelectedTamborrada() {
    var selectedPolyline = pathGroup[0];
    if (selectedPolyline) {
      var bounds = selectedPolyline.getBounds();
      myMap.fitBounds(bounds, { paddingTopLeft: [0, 80] });
    }
  }
  // #endregion

  return {
    init: init,
    drawQuarterCount: drawQuarterCount,
    eraseQuarterCount: eraseQuarterCount,
    zoomToFitAllQuarterCounts: zoomToFitAllQuarterCounts,
    drawStartingPoints: drawStartingPoints,
    eraseStartingPoints: eraseStartingPoints,
    zoomToFitAllStartingPoints: zoomToFitAllStartingPoints,
    drawPaths: drawPaths,
    erasePaths: erasePaths,
    zoomToSelectedTamborrada: zoomToSelectedTamborrada,
    getQuarterAreas: function() {
      return quarterAreas.slice(0);
    },
    getMyMap: function() {
      return myMap;
    }
  };
};
